import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { DomainValue } from "../../services/mdmService/types";
import { LogEntity } from "../../components/logsAndReports/reportAndLogsRowTypes";
import MasterDataTable from "../../components/dataUploadLayout/dataUploadHomeScreen/excelUpload/widgets/masterDataList/masterData";
import DataUploadCard from "../../components/dataUploadLayout/dataUploadHomeScreen/excelUpload/widgets/dataUploadSection/DataUploadCard";
import UpdatedMasterDataTable from "./UpdatedMasterDataTable";
import UpdatedDataUploadCard from "./UpdatedDataUploadCard";

export interface UpdatedExcelUploadParentScreenPropsTypes {
  showBeatMapping: boolean;
  handleStepIconClick: (stepNumber: number) => void;
  currentStep: number;
  completed: {
    [k: number]: boolean;
  };
  setCompleted: React.Dispatch<
    React.SetStateAction<{
      [k: number]: boolean;
    }>
  >;
  mdmData: DomainValue[];
  setMdmData: React.Dispatch<React.SetStateAction<DomainValue[]>>;
  handleScreenSwitch: (
    screen: "default" | "logs" | "edit" | "division"
  ) => void;
  setSelectedMaster: React.Dispatch<
    React.SetStateAction<DomainValue | undefined>
  >;
  selectedMaster: DomainValue | undefined;
  curData: LogEntity[];
  filteredData: LogEntity[];
  getLogs :  () => Promise<void>,
  isNextDisabled?: boolean;
}

export default function UpdatedExcelUploadParentScreen(
  props: UpdatedExcelUploadParentScreenPropsTypes
) {
 
  useEffect(()=>{

  },[props.selectedMaster])

  return (
    <Box
      className="excelUploadScreenContainer"
      sx={{
        height: props.isNextDisabled ? "64vh" : "80vh",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        marginLeft: "30px",
        marginRight: "30px",
      }}
    >
      <Box
        className="excelUploadScreenleftSection"
        sx={{
          backgroundColor: "white",
          height: props.isNextDisabled ? "100%" : "88%",
          width: "50%",
          overflow: "scroll",
          boxShadow: "2px 13px 54px #695F9714",
          borderRadius: "16px",
        }}
      >
        <UpdatedMasterDataTable
          showBeatMapping={props.showBeatMapping}
          mdmData={props.mdmData}
          setMdmData={props.setMdmData}
          setSelectedMaster={props.setSelectedMaster}
          selectedMaster={props.selectedMaster}
          handleScreenSwitch={props.handleScreenSwitch}
        />
      </Box>
      <Box
        className="excelUploadScreenRightSection"
        sx={{
          backgroundColor: "white",
          height: props.isNextDisabled ? "80%" : "75%",
          width: props.isNextDisabled ? "40%" : "45%",
          position: "absolute",
          top: props.isNextDisabled ? "125px" : "115px",
          right: props.isNextDisabled ? "30px" : "50px",
          boxShadow: "2px 13px 54px #695F9714",
          borderRadius: "16px",
          border: "1px solid #BCBCBC",
        }}
      >
        <div className="selected-master-ui">
          <UpdatedDataUploadCard
            setSelectedMaster={props.setSelectedMaster}
            selectedMaster={props.selectedMaster}
            handleScreenSwitch={props.handleScreenSwitch}
            curData={props.curData}
            filteredData={props.filteredData}
            getLogs={props.getLogs}
          />
        </div>
      </Box>
    </Box>
  );
}
